module.exports = __webpack_public_path__ + "fonts/Open_Sans-600-greek-ext21.7b7c4c1.woff2";